import { render, staticRenderFns } from "./SolGovernanca.vue?vue&type=template&id=be15da30&scoped=true&"
import script from "./SolGovernanca.vue?vue&type=script&lang=js&"
export * from "./SolGovernanca.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be15da30",
  null
  
)

export default component.exports